import { ElementRef } from "@angular/core";

export class IndexTyper {
    private letterTicks: number = 0;
    private wordTicks: number = 1;
    private words: string[] = [ "cards", "decks", "stats", "friends", "everything" ]

    private wordPause = 5;
    private wait = 10;

    public constructor(private elementRef: ElementRef<HTMLSpanElement>) {

    }

    public start(wait: number): void {
        setInterval(() => {
            this.tick();
        }, wait);
    }

    private tick(): void {
        if (this.wait > 0) {
            this.wait--;
            return;
        }

        var word = this.words[this.wordTicks % this.words.length];
        var display = word.substring(0, this.letterTicks);

        if (this.letterTicks >= word.length) {
            this.letterTicks = 1;
            this.wordTicks++;
            this.wait = this.wordPause;
        } else{
            this.letterTicks++;
        }

        this.elementRef.nativeElement.innerText = display;
    }
}